{
  "back": "返回",
  "form": "表单",
  "purposeTitle": "您此次停靠的目的是什么？",
  "appointmentInfoTitle": "预约信息",
  "appointmentInfoHint": "如果您已有预约，请务必填写此字段。",
  "checkInDetailsTitle": "签到详情",
  "checkInDetailsHint": "有关您此次到访的其他信息。",
  "driverPhoneLabel": "司机电话号码",
  "activateWhatsAppTitle": "启用 WhatsApp 消息",
  "activateWhatsAppBody": "如需与仓库沟通，请在收到我们发送的第一条 WhatsApp 消息后回复“OK”。",
  "whatsappDelayBanner": "第一条 WhatsApp 消息最长可能需要一分钟才能送达。",
  "notesLabel": "备注",
  "notesPlaceholder": "有没有需要告知仓库的特殊说明或备注？",
  "addNoteToWarehouse": "添加给仓库的备注",
  "verifyAndCheckIn": "验证并签到",
  "completeCheckIn": "完成签到",
  "visitGroupInbound": "入库",
  "visitGroupOutbound": "出库",
  "visitGroupBoth": "入库与出库",
  "visitUnloadTruck": "卸载我的卡车",
  "visitDropTrailer": "放下我的拖车或集装箱",
  "visitLoadTruck": "装载我的卡车",
  "visitHookTrailer": "挂接拖车或集装箱",
  "visitUnloadLoad": "卸载并装载我的卡车",
  "visitDropHook": "放下并挂接拖车或集装箱",
  "containerTrailer": "拖车",
  "containerContainer": "集装箱",
  "containerOversized": "超大件",
  "containerOther": "其他",
  "defaultReferenceName": "采购订单号（PO Number）",
  "identifierSuffix": "{reference} 或确认号",
  "licenseOrDotRequired": "请填写车牌号或 DOT 编号",
  "appointmentNotFound": "我们未能找到您的预约",
  "referenceNotFound": "未找到匹配的预约。参考号区分大小写。",
  "referenceCaseSensitiveHint": "参考号区分大小写",
  "messaging": {
    "whatsappFailedTitle": "无法发送 WhatsApp 消息",
    "smsFailedTitle": "无法发送短信",
    "whatsappFailedBody": "我们无法向 {displayPhone} 发送消息。<br /><br /> 如果您此前已取消订阅，请发送短信 START 至 <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a>，以重新开始接收来自该仓库的消息。",
    "smsFailedBody": "我们无法向 {displayPhone} 发送消息。<br /><br /> 如果您此前已取消订阅，请发送短信 START 至 <a href='{smsUrl}'>{senderPhone}</a>，以重新开始接收来自该仓库的短信。",
    "fallbackPhone": "所提供的电话号码"
  }
}
